import React, { useState } from "react";
import { Dialog } from "../ui/dialog";
import modalsContent from "../../../public/content/modals-content.json";
import ModalContentComponent from "./ModalContentComponent";
import EnquiryModal from "./EnquiryModal";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import { ModalState, StandardModalProps, ModalsContent } from "@/types";

const StandardModal: React.FC<StandardModalProps> = ({
  customClassName,
  isOpen,
  onClose,
  modalType,
}: StandardModalProps) => {
  const [modalState, setModalState] = useState<ModalState>({
    isEnquireModalOpen: false,
    isPrivacyPolicyModalOpen: false,
    isEmailSent: false,
  });

  const modalsData: ModalsContent[] = modalsContent as unknown as ModalsContent[];
  const modalData = modalsData.find((modal) => modal[modalType]);

  if (!modalData) {
    return null;
  }

  const columnLeftData = modalData[modalType]["column-left"];
  const imageUrl = modalData[modalType]["column-right"].image;

  const handleBackToHome = () => {
    setModalState({
      isEnquireModalOpen: false,
      isPrivacyPolicyModalOpen: false,
      isEmailSent: false,
    });
    onClose();
  };

  const extraRows = [
    {
      label: "Source",
      value: `Modal [${modalType}]`,
    },
  ];

  return (
    <>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <ModalContentComponent
          columnLeftData={columnLeftData}
          imageUrl={imageUrl}
          customClassName={customClassName}
          onClose={onClose}
          onEnquireClick={() =>
            setModalState({ ...modalState, isEnquireModalOpen: true })
          }
        />
      </Dialog>

      <EnquiryModal
        isOpen={modalState.isEnquireModalOpen}
        onClose={() => setModalState({ ...modalState, isEnquireModalOpen: false })}
        isEmailSent={modalState.isEmailSent}
        onEmailSent={() => setModalState({ ...modalState, isEmailSent: true })}
        onPrivacyPolicyClick={() =>
          setModalState({ ...modalState, isPrivacyPolicyModalOpen: true })
        }
        handleBackToHome={handleBackToHome}
        customClassName={customClassName}
        extraRows={extraRows}
      />

      <PrivacyPolicyModal
        isOpen={modalState.isPrivacyPolicyModalOpen}
        onClose={() => setModalState({ ...modalState, isPrivacyPolicyModalOpen: false })}
        customClassName={customClassName}
      />
    </>
  );
};

export default StandardModal;
